module.exports = __webpack_public_path__ + "static/media/auth-bg-1.1b9b626d.jpg";